module.exports = __webpack_public_path__ + "static/elzab-bdcdf03ae3f1efd550f24e1966f34212.png";